module.exports = __webpack_public_path__ + "static/media/it-procurement.eabf5a02.png";